var map = {
	"./Screenshot 2024-08-07 at 12.08.51 pm.png": 2098,
	"./Screenshot 2024-08-07 at 12.12.32 pm.png": 5876,
	"./Screenshot 2024-08-07 at 12.12.41 pm.png": 862,
	"./Screenshot 2024-08-10 at 11.10.51 pm.png": 5724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6136;